import { CharField } from "@inmagik/magik-ui"
import { getIn, useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import type { TextContent } from "../../types"
import { WysiwygField } from "../../components/WysiwygField"

export default function TextForm({ col = 12 }: { col?: number }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<TextContent>()

  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      <CharField
        label="Chiave"
        layout="horizontal"
        labelColSize={2}
        inputColSize={10}
        value={values.key}
        onChange={(value) => {
          setFieldValue("key", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "key") : undefined}
        errorMessage={getIn(errors, "key")}
        required
      />
      <WysiwygField
        label="Contenuto"
        labelColSize={2}
        inputColSize={10}
        layout="horizontal"
        value={values.content}
        onChange={(value) => {
          setFieldValue("content", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "content") : undefined}
        errorMessage={getIn(errors, "content")}
        required
      />
    </Col>
  )
}
